import Counter from "./counter";
export default Counter;